









import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { AccessLogUserModel } from "../models";

@Component
export default class AccessLogFilter extends Vue {
  @Prop({ required: true })
  value!: AccessLogUserModel[];
  @Prop({ required: true })
  logs!: AccessLogUserModel[];
  @Prop({ default: false })
  reload!: boolean;

  search = "";
  @Watch("search", { immediate: true })
  filterLogs(s: string) {
    const filtered = this.logs.filter((u: AccessLogUserModel): boolean => {
      if (
        s === "" ||
        String(u.id).includes(s) ||
        String(u.representee_id).includes(s) ||
        String(u.first_name).includes(s) ||
        String(u.last_name).includes(s) ||
        String(u.organisation_name).includes(s) ||
        String(u.email_address).includes(s)
      ) {
        return true;
      }

      for (let e of u.entries) {
        if (String(e.invoice_id).includes(s)) return true;
      }

      return false;
    });
    this.$emit("input", filtered);
  }

  @Watch("logs")
  onLogs() {
    this.filterLogs(this.search);
  }
}
